module.exports = __webpack_public_path__ + "static/pic13.1f5e24d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic13.jpg
// module id = 536
// module chunks = 35783957827783